(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-breadcrumb"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.getElementById('abtestbreadcrumb');
    if (!nav) return;
    var list = nav.querySelector('.breadcrumbs__list');
    if (!list) return;

    var centerParent = function () {
      // Nur wenn die Liste überhaupt scrollbar ist
      if (list.scrollWidth <= list.clientWidth) return;

      var items = list.querySelectorAll('.breadcrumbs__item');
      if (!items.length) return;

      // Mittleren Crumb (zuletzt besuchte Seite) zentrieren
      var target = list.querySelector('[data-crumb-parent]') ||
        (items.length > 1 ? items[items.length - 2] : items[0]);

      list.scrollLeft = target.offsetLeft - (list.clientWidth - target.offsetWidth) / 2;
    };

    centerParent();
    window.addEventListener('resize', centerParent);
  })();

  } catch(e) { console.error(e); }
})();
})();
